import { SalesPartnerCreateCustomerLanguageEnum } from "@/services/model/salesPartnerCreateCustomerLanguageEnum";
import { getDateString } from "@/utils/translationHelpers";

export const formatBirthday = (
  birthday: string | undefined,
): undefined | string => {
  if (!birthday) {
    return;
  }

  try {
    // Create a Date object from the birthday string
    const date = new Date(birthday);

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return "Invalid date";
    }

    // Format the date to dd.mm.yyyy
    return getDateString(date);
  } catch (error) {
    return "Invalid date";
  }
};

export const getSalutationDisplayText = (
  salutationEnum: string | undefined,
  t: (key: string) => string,
) => {
  if (!salutationEnum) return;

  switch (salutationEnum) {
    case "1":
      return t(
        "translation:Onboarding.sections.personal-details.form.formOfAddress.mr",
      );
    case "2":
      return t(
        "translation:Onboarding.sections.personal-details.form.formOfAddress.mrs",
      );
    case "0":
      return t(
        "translation:Onboarding.sections.personal-details.form.formOfAddress.other",
      );
    default:
      return;
  }
};

// Helper function to map language enum to translation key
export const getLanguageTranslationKey = (enumValue: string) => {
  const mapping: Record<string, string> = {
    [SalesPartnerCreateCustomerLanguageEnum.DE]: "1",
    [SalesPartnerCreateCustomerLanguageEnum.EN]: "2",
    [SalesPartnerCreateCustomerLanguageEnum.FR]: "3",
  };

  return mapping[enumValue] || enumValue;
};
